import { createSlice } from '@reduxjs/toolkit'

const  initialState= {
  value: {
    currProjectId: 0,

  }
}
export const paramSlice = createSlice({
  name: 'param',
  initialState,
  reducers: {
    setCurrProjectId: (state, action) => {
      state.value.currProjectId = action.payload
    },


  },
})

export const {
  setCurrProjectId
} = paramSlice.actions

export default paramSlice.reducer